import { createApi, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { AppState } from '@redux/store'
import { CartBundle } from '@typesApp/Product'
import { ActionModule } from '@typesApp/ActionModule'

export const cartApi = createApi({
  reducerPath: 'cartApi',
  baseQuery: fetchBaseQuery(),
  keepUnusedDataFor: 300,
  tagTypes: ['Cart'],
  endpoints: builder => ({
    getCartItems: builder.query<CartBundle, void>({
      queryFn: async (_args, queryApi, _extraOptions, _fetchFn) => {
        const state = queryApi.getState() as AppState
        const actionModule = state.connector.actionModule as ActionModule

        try {
          const data = await actionModule.getCartItemDetails()
          return { data }
        } catch (error) {
          return { error: error as FetchBaseQueryError }
        }
      },
    }),
  }),
})

export const { useGetCartItemsQuery, useLazyGetCartItemsQuery } = cartApi
